var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.053,
    height: 33.047,
    viewBox: "0 0 33.053 33.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_57653",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 57653",
    d: "M284.347,455.158l3.9,8.416,7.976.868a2.084,2.084,0,0,1,1.7,1.491,2.149,2.149,0,0,1-.621,2.2l-6.342,5.354,1.965,8.994a2.142,2.142,0,0,1-.824,2.124,2.029,2.029,0,0,1-2.23.119l-7.362-4.578-7.356,4.578a2.029,2.029,0,0,1-2.23-.119,2.142,2.142,0,0,1-.824-2.124l1.965-8.994-6.349-5.354a2.148,2.148,0,0,1-.619-2.2,2.082,2.082,0,0,1,1.7-1.488l7.976-.868,3.895-8.416a2.047,2.047,0,0,1,3.688,0Z",
    transform: "translate(-265.973 -453)",
    fill: "none",
    stroke: "#d5d5db",
    strokeWidth: 2,
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.7257ab5e.svg";
export { ForwardRef as ReactComponent };